<template>
  <div class="pbpoint">
    <div class="pbpoint__point" :class="'pbpoint__point_' + statename">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="currentColor"/>
        <path class="pbpoint__point-next" d="M18 30L24 24L18 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <path class="pbpoint__point-next" d="M24 30L30 24L24 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
        
        <path class="pbpoint__point-exclaim" d="M24.5 16V27" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <circle class="pbpoint__point-exclaim" cx="24.5" cy="31" r="1" fill="white"/>
        
        <path class="pbpoint__point-check" d="M15 23.4L22 30L33 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="pbpoint__strip">
      <div class="pbpoint__text" ref="text" :style="`width: ${textWidth}`">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    mounted: false,
    textWidth: 0
  }),
  mounted() {
    this.mounted = true
    document.fonts.ready.then(()=>this.updateWidth())
  },
  unmounted() {
    this.mounted = false
  },
  props: {
    text: { type: String, default: '' },
    state: { type: Number, default: 0},
  },
  methods: {
    updateWidth() {
      if (this.status) 
        this.textWidth = this.$refs.text.scrollWidth + 'px'
      else
        this.textWidth = 0
    }
  },
  computed: {
    ...mapState('ad_storage',['show']),
    active(){
      return this.state === 0
    },
    statename(){
      switch(this.state) {
        case -1:
          return 'next'
        case 0:
          return 'exclaim'
        case 1:
          return 'check'
      }
      return ''
    },
    status() {
      return (this.mounted && this.active & this.show)
    }
  },
  watch: {
    status(v, old) {
      if (v != old)
        this.$nextTick(this.updateWidth)
    }
  }
}
</script>

<style lang="sass" scoped>
.pbpoint
  --size: 48px
  display: flex
  letter-spacing: globalvars.$normspacing
  &__point
    position: relative
    z-index: 1
    width: var(--size)
    height: var(--size)
    transition: color .3s ease-out
    svg
      color: inherit
      width: 100%
      height: 100%
    &-next, &-exclaim, &-check
      transition: opacity .3s ease-out
      opacity: 0
    &_check
      color: #00B92D
    &_check &-check
      opacity: 1
    &_exclaim
      color: #F22557
    &_exclaim &-exclaim
      opacity: 1
    &_next
      color: #D2D4DA
    &_next &-next
      opacity: 1

  &__strip
    margin-left: calc(var(--size) * (-1))
    border-radius: 64px
    background: colors.$anothersilver
    padding: 13px 17px 11px 16px
    min-width: var(--size)
  &__text
    text-indent: var(--size)
    font-size: 15px
    line-height: 24px
    color: colors.$gray5
    white-space: nowrap
    overflow: hidden
    transition: width .4s ease
    letter-spacing: normal
  @include from(820px)
    --size: 44px
    align-items: center

    &__strip
      padding-top: 14px
      padding-bottom: 13px
      align-self: stretch
      display: flex
      align-items: center
    &__text
      font-size: 12px
      line-height: 1.14
      max-width: 100%
      white-space: nowrap
      letter-spacing: globalvars.$onespacing
</style>